import { RoutesService, eLayoutType } from '@abpdz/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eBillingPolicyNames } from './enums/policy-names';
import { eBillingRouteNames, eBillingRoutePaths } from './enums/route-names';

export const FACTURATION_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

function configureRoutes(routes: RoutesService): any {
  return () => {
    routes.add([
      {
        path: '/' + eBillingRoutePaths.Root + '/' + eBillingRoutePaths.TDB,

        name: eBillingRouteNames.TDB,
        requiredPolicy: eBillingPolicyNames.TDB,
        iconClass: 'monetization_on',
        order: 15,
        layout: eLayoutType.application,
      },
      {
        path:
          '/' + eBillingRoutePaths.Root + '/' + eBillingRoutePaths.opertations,

        name: eBillingRouteNames.opertations,
        requiredPolicy: eBillingPolicyNames.TDB,
        iconClass: 'admin_panel_settings',
        order: 20,
        layout: eLayoutType.application,
      },
      {
        path: '/' + eBillingRoutePaths.Root + '/' + eBillingRoutePaths.auditing,

        name: eBillingRouteNames.auditing,
        requiredPolicy: eBillingPolicyNames.TDB,
        iconClass: 'admin_panel_settings',
        order: 25,
        layout: eLayoutType.application,
      },
      {
        path: '/' + eBillingRoutePaths.Root + '/' + eBillingRoutePaths.fraud,
        name: eBillingRouteNames.fraud,
        requiredPolicy: eBillingPolicyNames.Fraud,
        iconClass: 'savings',
        order: 30,
        layout: eLayoutType.application,
      },
    ]);
  };
}
